import React, { useContext } from 'react'
// Components
import CTAButton from 'components/utils/Button/CTAButton'
import UIColumnFilter from 'components/utils/Filter/ColumnFilter'
// Styles
import { LockIcon, CheckIcon, EllipsisHIcon } from 'styles/fontAwesome'
// Additional
import { Tab } from 'static/tabs'
import { AccordionContext } from 'components/utils/Accordion/Accordion.context'
import { Routing } from 'helpers/routing'
import { TournamentRoundRecord } from 'data/TournamentRoundRecord'
import { RecordSetting } from 'components/utils/Table/_Table.settings'

export module Settings {
  export const get = (
    tournamentId?: string,
    options?: {
      disableNew?: boolean
    }
  ): RecordSetting<TournamentRoundRecord> => {
    return [
      {
        accessor: 'id',
        className: 'table-hidden',
      },
      {
        accessor: 'isFrozen',
        className: 'table-lock',
        Header: function HeaderContent({ row }: any) {
          return <LockIcon />
        },
        Cell: function CellContent({ row }: any) {
          return <>{row.values.isFrozen && <LockIcon />}</>
        },
      },
      {
        accessor: 'tournament_id',
        className: 'table-hidden',
      },
      {
        accessor: 'tournament_stage_id',
        className: 'table-hidden',
        Filter: function FilterContent(p: any) {
          return <UIColumnFilter from={Tab.Rounds} filter={p} />
        },
        filter: 'fuzzyText',
      },
      {
        accessor: 'tournamentStage_name',
        Header: 'Stage',
        className: 'table-stage',
      },
      {
        accessor: 'order_number',
        Header: 'Order',
        className: 'table-order',
      },
      {
        accessor: 'name',
        Header: 'Name',
        className: 'table-name',
      },
      {
        accessor: 'ident',
        Header: 'Ident',
        className: 'table-ident',
      },
      {
        accessor: 'isApproved',
        Header: 'Approved',
        className: 'table-approved',
        Cell: function CellContent({ row }: any) {
          return <>{row.values.isApproved && <CheckIcon />}</>
        },
      },
      {
        id: 'ctaButton',
        className: 'table-cta-button',
        sticky: 'right',
        Header: function HeaderContent({ row }: any) {
          const { toggle } = useContext(AccordionContext)

          if (options?.disableNew) return <></>

          return (
            <CTAButton onClick={toggle}>
              <EllipsisHIcon />
            </CTAButton>
          )
        },
        Cell: function CellContent({ row }: any) {
          return (
            <CTAButton
              path={Routing.getRoundDetailUrl({
                tournament: tournamentId ?? Routing.NewRecordSymbol,
                round: row.values.id,
              })}
            >
              {row.values.isFrozen ? 'View' : 'Edit'}
            </CTAButton>
          )
        },
      },
    ]
  }
}
